<template>
    <div class="block-progress">
        <span class="block-progress__title">
            Интересы <br> и развитие
        </span>
        <p class="block-progress__text">
            Интересы старшеклассника (зачастую вынужденные) можно выразить тремя буквами — ЕГЭ. Начиная с 9 класса учителя, кажется, говорят только об экзаменах и проходном балле. В&nbsp;16–17 лет, когда хочется только веселиться с друзьями и&nbsp;бездельничать, школьникам приходится делать выбор будущей профессии.
            <br>
            <br>
            Вместо учебы, которой сейчас приходится заниматься почти все время, хочется тусоваться с друзьями, смотреть Дудя и&nbsp;«Прожарку», вести блог или читать рэп. И подросток ухитряется совмещать все! А еще он может влюбиться и&nbsp;начать страдать или летать на крыльях, если чувства взаимны.
        </p>
        <div class="block-progress__img-box">
            <img
                srcset="../assets/top.jpg, ../assets/top@2x.jpg 2x"
                src="../assets/top.jpg"
                class="block-progress__img"
            />
            <div class="image-caption image-caption--overlap-left" style="text-align:left">Двор в проекте «Ярославский»</div>
        </div>
        <p class="block-progress__text block-progress--text-bottom">
            Некоторые старшеклассники еще до поступления начинают работать или волонтерить. Другие вместо вуза идут в&nbsp;профтехучилище или колледж. В&nbsp;этом случае их&nbsp;самостоятельная жизнь начинается на два года раньше.
        </p>
        <BlockParallax class="block-progress__icon-box block-progress__book" speed="11" direction="right" transform="rotate">
            <img
                src="@/assets/images/icons/1517-book.png"
                class="block-progress__icon"
            >
        </BlockParallax>
        <BlockParallax class="block-progress__icon-box block-progress__cup block-progress--icon-desktop" speed="13" direction="left" transform="rotate">
            <img
                src="@/assets/images/icons/1517-cup.png"
                class="block-progress__icon"
            >
        </BlockParallax>
        <BlockParallax class="block-progress__icon-box block-progress__heart-1" speed="16" direction="right" transform="rotate">
            <img
                src="@/assets/images/icons/1517-heart-blue.png"
                class="block-progress__icon"
            >
        </BlockParallax>
        <BlockParallax class="block-progress__icon-box block-progress__heart-2 block-progress--icon-desktop" speed="15" direction="left" transform="rotate">
            <img
                src="@/assets/images/icons/1517-heart-blue.png"
                class="block-progress__icon"
            >
        </BlockParallax>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'
// import ImageSlider from './slider'

export default {
    components: {
        BlockParallax
        // ImageSlider
    }
}
</script>

<style scoped lang="stylus">
    .block-progress {
        position relative
        +layout-sm-and-up() {
            display flex
            padding 0
            flex-wrap wrap
        }
        +layout-md-and-up() {
            margin-left 8rem
        }

        &__title {
            display block
            padding 0 2rem 0 5rem
            font-size 2.2rem
            line-height 2.6rem
            font-weight $font-semiBold
            color $color-text
            +layout-sm-and-up() {
                text-align center
                width 100%
                padding-right 7%
                font-size 3rem
                line-height 3.5rem
            }
            +layout-md-and-up() {
                margin-top 2rem
                text-align left
                position absolute
                left 0
                padding-left 0
            }

            br {
                display none
                +layout-md-and-up() {
                    display block
                }
            }
        }

        &__img-box {
            margin 2rem -1rem 0

            +layout-sm-and-up() {
                width 100%
                margin-left 0
                margin-right 0
            }

            +layout-md-and-up() {
                width 100%
                margin 5rem 8rem 4rem 0
            }
        }
        
        &__icon-box {
            position absolute
        }

        &__img {
            width 100%
            height auto
        }

        &__text {
            padding 0 2rem 0 5rem
            font-size 1.5rem
            line-height 1.47
            margin 1.7rem 0 0 0

            +layout-sm-and-up() {
                width 100%
            }

            +layout-md-and-up() {
                padding-left 25rem
                padding-right 14rem
            }
        }
        &--text-bottom {
            +layout-md-and-up() {
                padding-right 16rem
            }
        }

        &--icon-desktop {
            display none
            +layout-md-and-up() {
                display block
            }
        }

        &__cup {
            +layout-md-and-up() {
                top 22.2rem
                left -12rem
                width 9rem
                height 12rem
                z-index 0
                img {
                    transform rotate(-40deg)
                }
            }
        }

        &__book {
            right 1.5rem
            top -.5rem
            width 6rem
            z-index -1
            +layout-md-and-up() {
                position absolute
                right -6.3rem
                top 10rem
                width 12rem
                img {
                    transform rotate(155deg)
                }
            }
        }

        &__heart-1 {
            top 26rem
            left 5px
            width 2.6rem
            +layout-md-and-up() {
                width auto
                top auto
                bottom 5rem
                left 4rem
            }
        }
        &__heart-2 {
            +layout-md-and-up() {
                right 1rem
                top 33rem
                img {
                    transform rotate(75deg)
                }
            }
        }
    }
</style>
